import { makeAutoObservable, toJS } from 'mobx'
import newzxg from '../../modules/newzxg/web'
import { getDelayParam } from '../../modules/quote/web'
import { getCookie } from '../../components/shared/utils'

interface FavorList {
  name: string,
    code: string,
    market: number,
    new_price: number,
    zde: number,
    zdf: number,
    f1: number,
    f19: number,
    f128: number,
    f152: number,
}
class Store {
  constructor() {
    makeAutoObservable(this)
    this.init()
  }

  favors: Array<string> = []
  newFavors: Array<string> = []
  currentFavor = {gid: '', gname: '', fromclient: '', ver: 0, checkClass: ''}

  GroupList: any = {}
  GroupStocks: any = {}
  favorList: Array<FavorList> = []
  delayFavorList: Array<FavorList> = []

  currentFavorList: Array<FavorList> = []

  param = { cmd: '', pindex: 1, psize: 30, sr: 1, st: '' }
  delayTips = { hk_cn: false, hk_overseas: false }

  stockCodes: Array<string> = []
  title = '我的自选'
  manageBtn = '管理'
  stockScroll = 'stock-scroll'

  favorGroupVisible = false

  timer = null

  delayFlag = true

  async init() {
    let data = await this.getGroupList()
    this.setGroupList(data)
    this.setFavors(this.GroupList?.result?.map((v: any) => v.gid))
    this.setCurrentFavor(this.GroupList.result[0])

    let GroupStocks = await this.getGroupStockByID()
    store.setGroupStocks(GroupStocks)
    if (store.GroupStocks != null && store.GroupStocks.re && store.GroupStocks.result) {
      let stockCodes: Array<string> = store.GroupStocks.result.map((v: any) => v.code)
      const delayParam = await getDelayParam()
      if (delayParam) {
        this.getDelayQuote(JSON.parse(delayParam), stockCodes)
      }
    }
  }

  getGroupList() {
    return newzxg.groupList()
  }

  getGroupStockByID() {
    return newzxg.groupStockByID(this.newFavors.length ? this.newFavors?.[0] : this.favors?.[0])
  }

  // 获取延迟行情
  getDelayQuote(delayParam: any, stockCodes: Array<string>) {
    let isCN = delayParam?.lt == 1 ? true : false

    if(!stockCodes.length){
      this.setDelayTips({ hk_cn: false, hk_overseas: false })
      return
    }
    
    if (isCN) {
      //国内IP
      let uidal =  getCookie('uidal')
      let tempStockCodes = stockCodes.map((item: string) => {
        if (item.indexOf('116.') > -1 && !uidal) {
          //存在港股而且未登录
          item = item.replace(/116\./, '128.')
          this.setDelayTips({ hk_cn: true, hk_overseas: false })
        }
        return item
      })
      store.setStockCodes(tempStockCodes)
    } else {
      //非国内IP
      let tempStockCodes = stockCodes.map((item: string) => {
        if (item.indexOf('116.') > -1) {
          //存在港股不管是否登录都是延迟行情
          item = item.replace(/116\./, '128.')
          this.setDelayTips({ hk_cn: false, hk_overseas: true })
        }
        return item
      })
      store.setStockCodes(tempStockCodes)
    }
  }

  setFavors(favors: Array<string>) {
    this.favors = favors
  }

  setNewFavors(newFavors: Array<string>) {
    this.newFavors = newFavors
  }

  setCurrentFavor(currentFavor: { checkClass: string, fromclient: string,gid: string, gname: string, ver: number }) {
    this.currentFavor = currentFavor
  }

  setGroupList(GroupList: any) {
    GroupList &&
      GroupList.result.map((v: any) => {
        v.checkClass = 'icon-check'
      })
    this.GroupList = GroupList
  }

  setGroupStocks(GroupStocks: any) {
    this.GroupStocks = GroupStocks
  }

  setFavorList(favorList: Array<FavorList>) {
    this.favorList = favorList
  }

  setDelayFavorList(delayFavorList: Array<FavorList>) {
    this.delayFavorList = delayFavorList
  }

  setCurrentFavorList(currentFavorList: Array<FavorList>) {
    currentFavorList.map((item:FavorList)=>{
      item.market = item.market == 128 ? 116 : item.market
    })
    this.currentFavorList = currentFavorList
  }

  setParam(param: { cmd: string,pindex: number,psize: number, sr: number,st: string }) {
    this.param = param
  }

  setDelayTips(delayTips: { hk_cn: boolean; hk_overseas: boolean }) {
    this.delayTips = delayTips
  }

  setStockCodes(stockCodes: Array<string>) {
    this.stockCodes = stockCodes
  }

  setTitle(title: string) {
    this.title = title
  }

  setManageBtn(manageBtn: string) {
    this.manageBtn = manageBtn
  }

  setStockScroll(stockScroll: string) {
    this.stockScroll = stockScroll
  }

  setFavorGroupVisible(visible: boolean) {
    this.favorGroupVisible = visible
  }

  setCheckClass(index: number, style: string) {
    this.GroupList.result[index].checkClass = style
  }

  setTimer(timer: any) {
    this.timer = timer
  }

  setDelayFlag(delayFlag: any) {
    this.delayFlag = delayFlag
  }
}
const store = new Store()

export { store }
